import { useDropzone as useReactDropzone, DropzoneOptions as ReactDropzoneOptions } from "react-dropzone";

export const useDropzone = (options?: ReactDropzoneOptions) => {
  return useReactDropzone({ useFsAccessApi: false, ...options });
};
